export default {
    getCampusesWithActiveGroups: { method: 'get', url: 'class-now/campuses' },
    getBlocksForCampus:         { method: 'get', url: 'class-now/campuses/{campusId}/blocks' },
    getFloorsForCampus:         { method: 'get', url: 'class-now/campuses/{campusId}/floors' },
    getCoursesWithActiveGroups: { method: 'get', url: 'class-now/courses' },
    getGroupsByCourse:          { method: 'get', url: 'class-now/courses/{courseId}/groups' },
    getClassesTodayByCourse:    { method: 'get', url: 'class-now/courses/{courseId}/today' },
    getClassesTodayByGroup:     { method: 'get', url: 'class-now/groups/{groupId}/today' },
    generateReportAsync:        { method: 'post', url: 'class-now/report/async' },
}
